const { forEach } = require('lodash');

class FulfilmentTimeslotService {
    constructor(restangular) {
        this._api = restangular.all('Timeslots');
    }

    listTimeslots(areaId, fulfilmentMethod, suburbId = null, addressId = null, getMergedResults = false) {
        return this._api.getList({
            areaId, fulfilmentMethod, suburbId, getMergedResults, addressId,
        });
    }

    findReservedWindow(timeTable) {
        let reservedWindow = null;

        forEach(timeTable, (date) => {
            forEach(date.Times, (time) => {
                if (time.IsReserved) {
                    reservedWindow = { date, time };
                    return false;
                }

                return true;
            });
        });

        return reservedWindow;
    }
}

FulfilmentTimeslotService.$inject = ['Restangular'];

module.exports = { FulfilmentTimeslotService };



// WEBPACK FOOTER //
// ./src/fulfilment/timeslots/fulfilment-timeslot.service.js